import React from 'react';
import { View, StyleSheet } from 'react-native';
import {
  VictoryChart,
  VictoryAxis,
  VictoryBar,
  VictoryLabel,
  VictoryStack,
} from 'victory';

const BarChartUnitsPerWeek = ({ totalWeekly, limitWeek, maxWeeks }) => {
  // Break up the total in below, and over, the personal limit
  limitWeek = limitWeek || 0;
  const data = Object.entries(totalWeekly)
    .map(([key, value]) => {
      if (value <= limitWeek) {
        return { week: `v${key}`, below: value, above: 0, total: value };
      }
      return {
        week: `v${key}`,
        below: limitWeek,
        above: value - limitWeek,
        total: value,
      };
    })
    .slice(-1 * maxWeeks);

  const COLORS = ['rgba(134, 65, 244, 0.8)', '#8A0707'];
  const CUT_OFF = 1;

  // const sampleData = [
  //   { units: 1, week: 'v39' },
  //   { units: 0, week: 'v40' },
  //   { units: 2, week: 'v41' },
  //   { units: 13, week: 'v42' },
  //   { units: 4, week: 'v43' },
  // ];

  function CustomLabel({ x, y, datum }) {
    return datum.total <= CUT_OFF ? (
      <VictoryLabel
        style={{ fill: 'black', fontSize: 18 }}
        x={x}
        y={y}
        text={datum.total}
        dx={-5}
        dy={-10}
      />
    ) : (
      <VictoryLabel
        style={{ fill: 'white', fontSize: 18 }}
        x={x}
        y={y}
        text={datum.total}
        dx={-5}
        dy={15}
      />
    );
  }

  return (
    <View style={styles.chartContainer}>
      <VictoryChart>
        <VictoryAxis style={{ tickLabels: { fontSize: 20 } }} />
        <VictoryStack colorScale={COLORS}>
          <VictoryBar
            data={data}
            x="week"
            y="below"
            labels={({ datum }) => datum.units}
            labelComponent={<CustomLabel />}
            barRatio={0.9}
          />
          <VictoryBar data={data} x="week" y="above" barRatio={0.9} />
        </VictoryStack>
      </VictoryChart>
      <View style={styles.overlay} />
    </View>
  );
};

const styles = StyleSheet.create({
  chartContainer: {
    position: 'relative',
    flex: 1, // Adjust based on your layout needs
  },
  overlay: {
    ...StyleSheet.absoluteFillObject,
    backgroundColor: 'transparent', // Visible for debugging, change to 'transparent' to hide
  },
});

export default BarChartUnitsPerWeek;
